export class DocumentHistory {
  public archived = "";
  public changed = "";
  public changedBy = "";
  public fileName = "";
  public job = "";
}
